module.exports = __webpack_public_path__ + "static/img/bg_card_customers.a64e63b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_card_customers.svg
// module id = JdRv
// module chunks = 134